var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.ctaText)?_c('span',{staticClass:"action"},[_c('an-link',{attrs:{"variant":"primary"},on:{"click":_vm.onClickCta}},[_vm._v(_vm._s(_vm.ctaText))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }